import { render } from "./EditPhysicianRow.vue?vue&type=template&id=04f493fd&ts=true"
import script from "./EditPhysicianRow.ts?vue&type=script&lang=ts&external"
export * from "./EditPhysicianRow.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__